<template>
  <div>
    <Card>
      <Row>
        <Button type="info"
                @click="add">{{$t('pages_banners_index_178')}}</Button>
      </Row>
      <TablePaginate :columns="columns"
                     :data="score_rewards"
                     :loading="loading"
                     :meta="meta"
                     :changePage="changePage"></TablePaginate>
    </Card>
    <Modal v-model="modalShow"
           @on-ok="handleSubmit"
           :title="$t('pages_score_reward_index_927')">
      <Form :model="score_reward"
            :label-width="80">
        <Form-item :label="$t('pages_score_reward_index_928')"
                   prop="week">
          <Select label-in-value
                  v-model="score_reward.week">
            <Option v-for="item in scoreRewardWeeks"
                    :value="item.value"
                    :key="item.value">{{ item.name }}</Option>
          </Select>
        </Form-item>
         <Form-item :label="$t('pages_score_reward_index_929')"
                   prop="anniversary_day">
          <DatePicker type="date" format="MM-dd" :value="score_reward.anniversary_day" @on-change="(val)=>this.score_reward.anniversary_day = val" :placeholder="$t('pages_score_reward_index_930')" style="width: 200px"></DatePicker>
        </Form-item>
        <Form-item :label="$t('pages_score_reward_index_931')"
                   prop="multiple">
          <Input type="text" number
                 v-model="score_reward.multiple" />
        </Form-item>
        <Form-item :label="$t('pages_booking_store_products_index_220')"
                   prop="category">
          <Select label-in-value
                  v-model="score_reward.category">
            <Option v-for="item in scoreRewardCategories"
                    :value="item.value"
                    :key="item.value">{{ item.name }}</Option>
          </Select>
        </Form-item>
        <Form-item :label="$t('pages_balance_transaction_index_176')"
                   prop="is_running">
          <i-switch v-model="score_reward.is_running" size="large">
            <span slot="open">{{$t('pages_birthday_discount_index_208')}}</span>
            <span slot="close">{{$t('pages_birthday_discount_index_209')}}</span>
          </i-switch>
        </Form-item>
      </Form>
    </Modal>
  </div>
</template>

<script>
import i18n from '../../locales/index'

import { mapState, mapActions, mapMutations } from 'vuex'
import TablePaginate from '@/components/TablePaginate'
import { deleteButtonInTable, editorButtonInTable, booleanChinese, commonButtonInTable, weekText, scoreRewardcCategoryText } from '@/libs/table-render'
import { scoreRewardCategories, scoreRewardWeeks } from '@/libs/value-list'

export default {
  components: {
    TablePaginate,
  },
  data () {
    return {
      modalShow: false,
      formType: '',
      columns: [
        {
          title: i18n.t('pages_booking_store_products_index_220'),
          key: 'category',
          align: 'center',
          render: (h, params) => {
            return h('div', scoreRewardcCategoryText(params.row.category))
          }
        },
        {
          title: i18n.t('pages_score_reward_index_931'),
          key: 'multiple'
        },
        {
          title: i18n.t('pages_score_reward_index_932'),
          key: 'week',
          align: 'center',
          render: (h, params) => {
            return h('div', weekText(params.row.week))
          }
        },
        {
          title: i18n.t('libs_table_render_97'),
          key: 'anniversary_day'
        },
        {
          title: i18n.t('pages_balance_transaction_index_177'),
          key: 'created_at'
        },
        {
          title: i18n.t('pages_birthday_discount_index_208'),
          key: 'is_running',
          align: 'center',
          render: (h, params) => {
            const children = []
            children.push(booleanChinese(
              h,
              params.row.is_running))
            return h('div', children)
          }
        },
        {
          title: i18n.t('pages_ai_image_163'),
          key: 'action',
          width: 300,
          align: 'center',
          render: (h, params) => {
            const children = []
            children.push(deleteButtonInTable(this, h, params))
            children.push(editorButtonInTable(this, h, params))
            children.push(commonButtonInTable(this,
              h,
              'info',
              i18n.t('pages_schedule_display_product_index_923'),
              this.handleRun,
              [params.row]))
            return h('div', children)
          }
        }
      ],
      searchProducts: {
        query: ''
      },
      scoreRewardCategories,
      scoreRewardWeeks
    }
  },
  created () {
    this.changeQuery({ page: 1 })
    this.index()
  },
  computed: {
    ...mapState('score_reward', ['score_reward', 'score_rewards', 'meta', 'loading']),
  },
  methods: {
    ...mapActions('score_reward', [
      'clear',
      'index',
      'show',
      'create',
      'update',
      'destroy',
      'run'
    ]),
    ...mapMutations('score_reward', ['changeQuery']),
    async handleRun (params) {
      await this.run(params);
      await this.index()
    },
    changePage (page) {
      this.changeQuery({ page: page })
      this.index()
    },
    add () {
      this.clear()
      this.modalShow = true
      this.formType = 'new'
    },
    async handleSubmit () {
      if (this.formType === 'edit') {
        await this.update(this.score_reward)
      } else if (this.formType === 'new') {
        await this.create(this.score_reward)
      }
      this.modalShow = false
    },
  }
}
</script>
